import PropTypes from 'prop-types'
import React from 'react'

import SectionWrapper from 'components/SectionWrapper'
import { Text, H1Small as H1 } from 'styles/components/typography'

import { FrameBrowserStyled, FrameWrapper, Content, Cover } from './styles'

const IMAGE = 'traits'

const WResultsTraits = ({ data, pathCdn }) => (
  <SectionWrapper
    isOverflowHidden={true}
    beforeElement={<Cover isTablet={true} />}
  >
    <div className="row">
      <div className="col-12 order-md-1 col-md-8">
        <Cover />
        <FrameWrapper className="py-md-4">
          <div className="position-relative py-4 py-md-0">
            <H1 as="h2" dangerouslySetInnerHTML={{ __html: data.title }} />
            <FrameBrowserStyled
              colorTheme="dark"
              src={`${pathCdn}/${IMAGE}`}
              alt={IMAGE}
            />
          </div>
        </FrameWrapper>
      </div>
      <div className="col-12 py-4 order-md-0 col-md-4">
        <Content>
          <Text dangerouslySetInnerHTML={{ __html: data.content }} />
        </Content>
      </div>
    </div>
  </SectionWrapper>
)

WResultsTraits.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default WResultsTraits
